<template>
    <div>
        <h4 class="mt-1">
            {{ bonusDetails.title }}
        </h4>
        <p class="mb-0">
            {{ bonusDetails.subtitle }}
        </p>
        <div class="row mb-1">
            <div class="col-11 col-sm-10 col-md-8 col-lg-6">
                <p class="d-flex py-0 mb-0">
                    <span v-html="bonusDetails.example.first.item" />
                    <span class="ms-auto" v-html="bonusDetails.example.first.value" />
                </p>
                <div class="w-100" />
                <p class="d-flex py-0 mb-0">
                    <span v-html="bonusDetails.example.second.item" />
                    <span class="ms-auto" v-html="bonusDetails.example.second.value" />
                </p>
                <div class="w-100" />
                <ob1-separateur class="my-1" />
                <div class="w-100" />
                <p class="d-flex py-0 mb-0">
                    <span v-html="bonusDetails.example.third.item" />
                    <span class="mt-auto ms-auto" v-html="bonusDetails.example.third.value" />
                </p>
            </div>
        </div>
        <div class="text-mw">
            <p class="mb-0" v-html="bonusDetails.modelMention" />
            <p class="mb-0" v-html="condition" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        bonusDetails: {
            type: Object,
            required: true
        },
        condition: {
            type: String,
            required: true
        }
    }
}

</script>
